export default __webpack_public_path__ + "static/media/dg-img.23f05477.webp";